// General
import React, { useContext } from "react";
// Styles
import { Modal } from "react-bootstrap";
import { TextField, Autocomplete } from "@mui/material";
// Formik
import { Formik, Form } from "formik";
// Contexts
import { CashContext } from "../../data/cash/CashContext";
import { useValidations } from "../../data/ValidationContext";
// Components
import CapitalizedFormikField from "../../components/CapitalizedFormikField";


// Seçenekler
const PAYMENT_DIRECTIONS = [
  { value: "", label: "Ödeme Yönü Seçiniz" },
  { value: "Gelir", label: "Gelir" },
  { value: "Gider", label: "Gider" },
];

const PAYMENT_METHODS = [
  { value: "", label: "Seçiniz" },
  { value: "Nakit", label: "Nakit" },
  { value: "Havale", label: "Havale" },
  { value: "Kredi Kartı", label: "Kredi Kartı" },
];

const STATUS_OPTIONS = [
  { value: "", label: "Seçiniz" },
  { value: "Beklemede", label: "Beklemede" },
  { value: "Tamamlandı", label: "Tamamlandı" },
];

const INSTALLMENT_OPTIONS = [
  { value: "", label: "Seçiniz" },
  { value: "Tek Çekim", label: "Tek Çekim" },
  { value: "2 Taksit", label: "2 Taksit" },
  { value: "3 Taksit", label: "3 Taksit" },
  { value: "6 Taksit", label: "6 Taksit" },
];

function CashAddModal({ show, handleClose }) {
  const { addCash } = useContext(CashContext);
  const { vs_cash } = useValidations();

  const initialValues = {
    date: "",
    paymentType: "",
    paymentDirection: "",
    paymentMethod: "",
    status: "",
    realizationDate: "",
    installment: "",
    amount: "",
    description: "",
  };

  const fieldWrapperStyle = { marginBottom: "1rem" }; // boşluğu biraz artırdık

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Kasa Kaydı Ekle</Modal.Title>
      </Modal.Header>

      <Formik
        initialValues={initialValues}
        validationSchema={vs_cash}
        onSubmit={(values, { resetForm }) => {
          addCash(values);
          resetForm();
          handleClose();
        }}
      >
        {({ values, setFieldValue, touched, errors }) => (
          <Form>
            <Modal.Body>
              {/* Tarih ve Ödeme Türü */}
              <div className="row mb-2">
                <div className="col" style={fieldWrapperStyle}>
                  <CapitalizedFormikField
                    type="date"
                    name="date"
                    variant="outlined"
                    size="small"
                    fullWidth
                    error={touched.date && !!errors.date}
                    helperText={touched.date && errors.date}
                  />
                </div>
                <div className="col" style={fieldWrapperStyle}>
                  <CapitalizedFormikField
                    name="paymentType"
                    label="Ödeme Türü"
                    variant="outlined"
                    size="small"
                    fullWidth
                    error={touched.paymentType && !!errors.paymentType}
                    helperText={touched.paymentType && errors.paymentType}
                  />
                </div>
              </div>

              {/* Ödeme Yönü ve Şekli */}
              <div className="row mb-2">
                <div className="col" style={fieldWrapperStyle}>
                  <CapitalizedFormikField
                    select
                    name="paymentDirection"
                    label="Ödeme Yönü"
                    variant="outlined"
                    size="small"
                    fullWidth
                    SelectProps={{ native: true }}
                    error={touched.paymentDirection && !!errors.paymentDirection}
                    helperText={touched.paymentDirection && errors.paymentDirection}
                  >
                    {PAYMENT_DIRECTIONS.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                       
                      </option>
                    ))}
                  </CapitalizedFormikField>
                </div>
                <div className="col" style={fieldWrapperStyle}>
                  <CapitalizedFormikField
                    select
                    name="paymentMethod"
                    label="Ödeme Şekli"
                    variant="outlined"
                    size="small"
                    fullWidth
                    SelectProps={{ native: true }}
                    error={touched.paymentMethod && !!errors.paymentMethod}
                    helperText={touched.paymentMethod && errors.paymentMethod}
                  >
                    {PAYMENT_METHODS.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                       
                      </option>
                    ))}
                  </CapitalizedFormikField>
                </div>
              </div>

             

              {/* Taksit/Vade ve Tutar */}
              <div className="row mb-2">
                <div className="col" style={fieldWrapperStyle}>
                  <Autocomplete
                    options={INSTALLMENT_OPTIONS}
                   
                   
                    onChange={(event, newValue) =>
                      setFieldValue("installment", newValue ? newValue.value : "")
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Taksit/Vade"
                        size="small"
                        variant="outlined"
                        fullWidth
                        error={touched.installment && !!errors.installment}
                        helperText={touched.installment && errors.installment}
                      />
                    )}
                  />
                </div>
                <div className="col" style={fieldWrapperStyle}>
                  <CapitalizedFormikField
                    type="number"
                    name="amount"
                    label="₺"
                    variant="outlined"
                    size="small"
                    fullWidth
                    error={touched.amount && !!errors.amount}
                    helperText={touched.amount && errors.amount}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/\D/g, ""))
                    }
                  />
                </div>
              </div>

              {/* Açıklama */}
              <div style={fieldWrapperStyle}>
                <CapitalizedFormikField
                  name="description"
                  label="Açıklama"
                  variant="outlined"
                  size="small"
                  fullWidth
                  multiline
                  rows={2}
                  error={touched.description && !!errors.description}
                  helperText={touched.description && errors.description}
                />
              </div>
            </Modal.Body>

            <Modal.Footer>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                İptal
              </button>
              <button type="submit" className="btn btn-primary">
                Kaydet
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export default CashAddModal;
